import casesEdit from './edit.vue'
import casesList from './list.vue'
import * as casescategoryList from './category'

let a = Object.assign({ casesEdit, casesList}, casescategoryList)
export default a;